<template>
    <div class="mt-10">
        <div class="row" v-if="downloading">
            <div class="col-lg-12 text-center">
                <b-spinner small label="Espere ..."></b-spinner>
                <label for="">Cargando conversación ...</label>
            </div>
        </div>
        <div class="container" v-if="!downloading">
            <div class="row">
                <div class="col-lg-4">
                    <div class="job b-white rounded shadow-sm p-3">
                        <small>Empleo</small>
                        <h5 class="font-blue">{{conversationData.job.titulo}}</h5>
                        <div class="e-name font-size-11 font-gray-dark">{{conversationData.job.enterprise_min.name}}</div>
                        <div class="e-location font-size-11 font-gray-dark">{{conversationData.job.enterprise_min.location}}</div>
                        <hr>
                        <router-link :to="'/enterprise/' + conversationData.job.enterprise_min.url_public + '/job/' + conversationData.job.url_public" class="font-gray-dark">Ver empleo</router-link>
                    </div>
                </div>
                
                <div class="col-lg-8">
                    <div class="confirm-message text-center" v-if="!conversationData.confirm">
                        <h3 class="fas fa-envelope font-blue"></h3>
                        <h5>Confirmar conversación</h5>
                        <div v-if="typeOrigin == 'enterprise'">
                            Esperando confirmación de <b>{{conversationData.user.name}}</b> para iniciar un proceso de conversación. <br>
                            Te notificaremos cuando tu candidato haya autorizado tu petición.
                        </div>

                        <div v-if="typeOrigin == 'student'">
                            La empresa <b>{{conversationData.job.enterprise_min.name}}</b> esta intentando ponerse en contacto contigo <br>
                            para inciar una conversación es necesario que aceptes la conversación.
                        </div>
                    </div>

                    <div class="confirmed" v-else>
                        <!--WriteMessage-->
                        <div class="write">
                            <label for="">Escribe un mensaje:</label>
                            <b-form @submit="sendMessage">
                                <b-form-textarea
                                    class="mb-3"
                                    v-model="form.message"
                                    placeholder="Enter something..."
                                    rows="3"
                                    max-rows="6"
                                    required>
                                </b-form-textarea>
                                    <div class="min-tools">
                                        <b-button type="submit" class="b-orange shadow-sm" :disabled="loading.sendMessage">
                                            <b-spinner v-show="loading.sendMessage" small label="Espere ..."></b-spinner>
                                            <i class="far fa-paper-plane" v-show="!loading.sendMessage"></i> 
                                            Enviar Mensaje
                                        </b-button>

                                        <b-button type="button" v-if="typeOrigin == 'enterprise'" @click="toolsMax = !toolsMax" class="b-white shadow-sm font-blue"><i class="fas fa-cog"></i></b-button>
                                        <b-button type="button" v-if="toolsMax && typeOrigin == 'enterprise'" class="b-red shadow-sm float-right shadow-sm" @click="removeConversation" :disabled="loading.removeConversation">
                                            <b-spinner v-show="loading.removeConversation" small label="Espere ..."></b-spinner>
                                            Cancelar conversación
                                        </b-button>
                                    </div>
                            </b-form>
                        </div>
                        <hr>
                        <!--ListMessage-->
                        <div class="message b-white  b-shadow p-2" v-for="message in conversationData.messages" :key="message.id">
                            <div class="name font-weight-bold font-blue">{{message.user.name}}</div>
                            <div class="message-text ">
                                {{message.message}}
                            </div>
                            <div class="time">
                                <small class="font-gray-dark">hace {{message.created_at | timeDateHummand}}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    .message{
        border-radius: 10px 10px 10px 0;
        margin-bottom: .5em;
    }
</style>
<script>
export default {
    data() {
        return {
            downloading: true,
            toolsMax: false,
            conversation_url: this.$route.params.conversation_url,
            conversationData: [],
            defaultImage: require('@/assets/profile/user_empty.png'),
            form:{
                conversation_id: null,
                message: ''
            },
            loading:{
                sendMessage: false,
                removeConversation: false,
            }
        }
    },
    watch: {
        conversationData: function(val){
            this.form.conversation_id = val.id
        }
    },
    computed: {
       typeOrigin: function(){ return this.$store.getters.typeOrigin } 
    },
    methods:{
        loadConversation(){
            this.downloading = true
            this.api.get('conversation/read?conversation_url=' + this.conversation_url).then(({data}) => {
                console.log('DATA::: ', data)
                this.conversationData = data
                this.downloading = false
                this.$bus.$emit("message")
            }).catch(err =>{
                this.downloading = false
            })
        },
        sendMessage(e){
            e.preventDefault()
            this.loading.sendMessage = true
            this.api.post('conversation/message', JSON.stringify(this.form)).then(({data}) => {
                this.loading.sendMessage = false
                this.form.message = ''
                this.toast(data.message)
            }).catch(err => {
                this.loading.sendMessage = false

            })
        },
        removeConversation(){
            this.loading.removeConversation = true
            this.api.delete('conversation?conversation_id=' + this.form.conversation_id).then(({data}) => {
                this.loading.removeConversation = false
                this.$router.push('/profile/candidates')
            }).catch(err => {
                this.loading.removeConversation = false                
            })
        },
        confirm(status){
            let formStatus = {
                job_id: this.form.conversation_id,
                status: status
            }

            this.api.put('conversation', JSON.stringify(formStatus)).then(({data}) => {
                console.log(data)
            })
        },
        toast(message){
            this.$bvToast.toast(message, {
                title: "Kllaar.com",
                variant: 'success',
                toaster: 'b-toaster-bottom-right',
                solid: true,
                appendToast: true
            })
        }
    },
    created() {
      let conversation_url = this.$route.params.conversation_url
      if(conversation_url == undefined){
            window.close()
      }else{
          this.loadConversation()
      }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/#pages/conversation/Conversation.vue